module.exports = __webpack_public_path__ + "static/img/bbc-five-live.a763667.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/thumbs/bbc-five-live.png
// module id = 5LWP
// module chunks = 0